import { RudderAnalytics } from '@rudderstack/analytics-js/bundled';

const analytics = new RudderAnalytics();
analytics.load(
  import.meta.env.REACT_APP_RUDDERSTACK_API_KEY as string,
  import.meta.env.REACT_APP_RUDDERSTACK_DATAPLANE_URL as string,
  {
    integrations: { All: true },
  },
);

export const identify = (userId: string) => {
  analytics.identify(userId);
};

export const pageView = (name: string) => {
  analytics.page(name, {
    path: window.location.pathname,
  });
};

export const track = (
  eventType: string,
  eventProperties: Record<string, string | number | boolean>,
) => {
  analytics.track(eventType, eventProperties);
};
